const REASON_LABELS: any = {
    NOT_STARTED: '운용 시스템을 시작해주세요.',
    TARGET_NOT_CONFIGURED: '운용 종목을 선택해주세요.',
    LIVE_BUDGET_NOT_APPROVED: '설정에서 운용 금액을 확인해주세요.',
    BUDGET_MODE_INVALID: '설정에서 운용 금액 방식을 다시 선택해주세요.',
    AUTO_BUDGET_TOO_SMALL: '현재 안전 매수 가능 금액이 10만원 미만입니다.',
    ACCOUNT_READ_REQUIRED: 'KIS 계좌 조회 연결을 확인해주세요.',
    INSUFFICIENT_BUYING_POWER: '현재 주문 가능 금액이 부족합니다.',
    ORPHAN_EXECUTION_STATE: '주문 원장 상태를 확인해주세요.',
    STALE_PREPARED_INTENT: '오래된 미전송 매수를 폐기했습니다. 다시 시작해주세요.',
    ACCOUNT_MISSING: '실전 준비 확인을 실행해주세요.',
    ACCOUNT_UNRECONCILED: 'KIS 잔고를 다시 확인해주세요.',
    MARKET_HOLIDAY: '오늘은 휴장일입니다.',
    MARKET_PREMARKET: '장 시작을 기다리고 있습니다.', MARKET_PRE_MARKET: '장 시작을 기다리고 있습니다.', MARKET_WARMUP: '장 초반 흐름을 확인하고 있습니다.',
    MARKET_CANCEL_ONLY: '장 마감이 가까워 새 주문을 멈췄습니다.',
    MARKET_CLOSE_AUCTION_OBSERVE: '장 마감 가격을 확인하고 있습니다.',
    MARKET_AFTER_HOURS: '오늘 정규장이 끝났습니다.', MARKET_POST_MARKET: '오늘 정규장이 끝났습니다.',
    MARKET_CLOSED: '오늘 장이 끝났습니다.',
    MARKET_CALENDAR_UNKNOWN: '거래 일정을 확인하고 있습니다.',
    MARKET_OPEN_AUTO_WAITING: '다음 정규장 시작을 기다리고 있습니다.',
    MARKET_OPEN_AUTO_STARTED: '장 시작 자동매수를 준비했습니다.',
    MARKET_OPEN_AUTO_CHECKING: '장 시작 안전 상태를 확인하고 있습니다.',
    MARKET_OPEN_AUTO_MISSED: '오늘 신규 매수 시간이 지나 다음 장을 기다립니다.',
    AUTO_START_DATE_INVALID: '자동 시작 날짜를 확인해주세요.',
    AUTO_START_SETTLING: '장 시작 안전 상태를 한 번 더 확인하고 있습니다.',
    DAILY_CYCLE_LIMIT_REACHED: '이전 운용 상태를 갱신하고 있습니다.',
    REALTIME_ENTRY_WAITING: '전일 종가 기준 매수 조건을 확인하고 있습니다.',
    REALTIME_MANAGEMENT_WAITING: '실시간 가격으로 보유 종목을 관리하고 있습니다.',
    NO_REALTIME_TRIGGER: '매수·매도 가격을 기다리고 있습니다.',
    CONTINUOUS_ADD_SLICE_WAITING: '추가매수 정책에 따른 주문가능금액 또는 운용 여력으로 1주를 살 수 없어 대기합니다.',
    CONTINUOUS_ADD_CASH_CHANGED: '주문가능금액이 달라져 추가매수 수량을 다시 계산합니다.',
    RECOVERY_CONTINUOUS_CASH_CHANGED: '복구 주문의 주문가능금액과 운용한도를 다시 확인해주세요.',
    TRIGGER_NO_LONGER_ACTIONABLE: '가격이 기준선에서 벗어나 주문하지 않았습니다.',
    TRIGGER_CHANGED_BEFORE_ORDER: '주문 직전 가격이 달라져 주문하지 않았습니다.',
    COST_EVIDENCE_COST_PENDING: '증권사 수수료·세금 집계를 다시 확인하고 있습니다.',
    COST_EVIDENCE_CASH_DELTA: '매매 외 현금 이동 또는 정산 차이가 있어 계좌 확인이 필요합니다.',
    REALTIME_ACCOUNT_BACKOFF: '계좌 확인 뒤 잠시 가격을 지켜보고 있습니다.',
    DAY_REFERENCE: '오늘 가격 기준을 다시 확인하고 있습니다.', DAY_REFERENCE_WAIT: '첫 체결로 오늘 시초가를 확인하고 있습니다.',
    DAY_REFERENCE_CONFLICT: '시초가 또는 전일 종가 정보가 달라 자동매수를 중지했습니다.',
    NO_CURRENT_FINAL_BAR: '오늘 확정 1분봉을 기다리고 있습니다.',
    BAR_ALREADY_EVALUATED: '다음 확정 1분봉을 기다리고 있습니다.',
    BUY_PAUSED: '새 매수가 중지되어 있습니다.',
    NO_SIGNAL: '조건에 맞는 움직임을 기다리고 있습니다.',
    ORDER_PLAN_ONLY: '주문 전 안전 조건을 확인하고 있습니다.',
    ORDER_SUBMITTED: 'KIS 주문 접수 결과를 확인하고 있습니다.',
    ENTRY_RESERVATION_WINDOW_CANCEL_REQUESTED: '첫 매수 예약을 마감하고 있습니다.',
    ENTRY_RESERVATION_PAUSE_CANCEL_REQUESTED: '첫 매수 예약을 취소하고 있습니다.',
    UNEXPECTED_BROKER_OPEN_ORDER: 'KIS 앱의 미체결 주문을 확인해주세요.',
    UNEXPECTED_BROKER_HOLDING: 'KIS 앱의 다른 종목 보유분을 확인해주세요.',
    CREDIT_OR_LOAN_POSITION: '신용·대출 보유분은 자동 운용할 수 없습니다.'
};

const STATUS_LABELS: any = {
    RESERVED: '전송 전', SUBMITTING: '접수 중', OPEN: '미체결',
    PARTIALLY_FILLED: '부분체결', CANCEL_PENDING: '취소 중',
    UNKNOWN: '확인 중', FILLED: '체결', CANCELLED: '취소',
    REJECTED: '거절', ENTRY_PENDING: '첫 매수 대기',
    ACTIVE: '진행 중', REVIEW_REQUIRED: '확인 필요', COMPLETE: '완료'
};

const SESSION_LABELS: any = {
    PREMARKET: '장 전',
    PRE_MARKET: '장 전',
    REGULAR: '장 중',
    AFTER_HOURS: '장 후',
    POST_MARKET: '장 후',
    HOLIDAY: '휴장',
    CALENDAR_UNKNOWN: '일정 확인 중'
};

const READINESS_ISSUES: any[] = [
    { key: 'target', message: '운용 종목을 먼저 선택해주세요.', action: 'target' },
    { key: 'kis', message: 'KIS 연결을 다시 확인해주세요.', action: 'settings' },
    { key: 'live_budget', message: '운용 금액을 확인해주세요.', action: 'settings' },
    { key: 'account', message: 'KIS 계좌를 다시 확인해주세요.', action: 'settings' },
    { key: 'order_server', message: '운용 시스템이 꺼져 있습니다.', action: 'system' },
    { key: 'realtime', message: '실시간 시세를 연결하고 있습니다.', action: '' },
    { key: 'live_order', message: '실주문 서버 설정이 잠겨 있습니다.', action: '' },
    { key: 'backup', message: '안전 확인이 끝날 때까지 기다려주세요.', action: '' }
];

// Presentation only: UNKNOWN still blocks new orders in the execution ledger.
export function isTemporaryOrderReadDelay(order: any) {
    return order?.status === 'UNKNOWN'
        && order.broker_order_saved === true
        && /^RECONCILIATION_(DAILY_ORDERS|OPEN_ORDERS|BALANCE|TRADE_COSTS)_(RATE_LIMIT|NETWORK|PROVIDER)$/.test(
            String(order.reason || '')
        );
}
export function reasonLabel(reason: string) {
    if (REASON_LABELS[reason]) return REASON_LABELS[reason];
    if (reason.startsWith('ACTIVE_ORDER_')) {
        return '주문 체결 상태를 확인하고 있습니다.';
    }
    if (reason.startsWith('ORDER_')) return '주문 상태를 확인해주세요.';
    return '운용 상태를 확인해주세요.';
}
export function statusLabel(status: string) {
    return STATUS_LABELS[status] || '확인 필요';
}
export function marketSessionLabel(
    session: string, serverAt = '', marketOpenAt = ''
) {
    const current = String(session || 'CALENDAR_UNKNOWN').toUpperCase();
    if (current === 'CLOSED') {
        const serverTime = Date.parse(serverAt);
        const openTime = Date.parse(marketOpenAt);
        return Number.isFinite(serverTime) && Number.isFinite(openTime)
            && serverTime < openTime ? '장 전' : '장 마감';
    }
    return SESSION_LABELS[current] || SESSION_LABELS.CALENDAR_UNKNOWN;
}
export function showsLastRegularBar(session: string) {
    return String(session || '').toUpperCase() !== 'REGULAR';
}
export function readinessIssue(readiness: any) {
    return READINESS_ISSUES.find(item => !readiness?.[item.key]) || {
        key: '', message: '최신 운용 상태를 다시 확인해주세요.', action: ''
    };
}
